import { render, staticRenderFns } from "./createIngressos.vue?vue&type=template&id=6818acce&scoped=true&"
import script from "./createIngressos.vue?vue&type=script&lang=js&"
export * from "./createIngressos.vue?vue&type=script&lang=js&"
import style0 from "./createIngressos.vue?vue&type=style&index=0&id=6818acce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6818acce",
  null
  
)

export default component.exports